export default "__VITE_ASSET__DHhTRlUY__"